module.exports = __webpack_public_path__ + "static/media/anatomia.d5dbef9b.png";